import { render } from "./WeeksTab.vue?vue&type=template&id=28142b7f&ts=true"
import script from "./WeeksTab.vue?vue&type=script&lang=ts"
export * from "./WeeksTab.vue?vue&type=script&lang=ts"

import "./WeeksTab.vue?vue&type=style&index=0&id=28142b7f&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__